﻿$(function () {
    if ($("#calculate_delivery_fee").length) {
        if ($.validator) {
            $("#calculateForm").validate({
                ignore: [],
                errorElementClass: 'error',
                errorClass: 'error-item',
                errorElement: 'span',
                rules: {
                    LorryType: {
                        required: true
                    },
                    DeliveryAdress: {
                        required: true
                    },
                    Quantity: {
                        required: true,
                        pattern: /^[1-9](\d*|\d*[,\.]\d+)$/ // Number > 0 with . or , decimal separator
                    },
                    DeliveryDate: {
                        required: true,
                        swedishDate: true
                    },
                    Artikel_Frakt: {
                        required: true
                    }
                },
                messages: {
                    LorryType: {
                        required: "Du måste välja leveranssätt"
                    },
                    DeliveryAdress: {
                        required: "Du måste välja en leveransadress"
                    },
                    Quantity: {
                        required: "Du måste ange en kvantitet större än 0",
                        pattern: "Ange ett numeriskt värde större än 1"
                    },
                    DeliveryDate: {
                        required: "Du måste ange ett giltigt datum",
                        swedishDate: "Du måste ange ett giltigt datum"
                    },
                    Artikel_Frakt: {
                        required: "Du måste välja en artikel"
                    }
                },
                highlight: function (element, errorClass, validClass) {
                    $('ul.errors-list').show();
                    $('ul.errors-list').parent().show();
                    $('li#p_' + $(element).attr('id')).show();
                    element = this.settings._getIndicatorElement(element);
                    $(element).addClass(this.settings.errorElementClass).removeClass(errorClass);
                },
                unhighlight: function (element, errorClass, validClass) {
                    $('li#p_' + $(element).attr('id')).hide();
                    if ($('ul.errors-list').find('li[id^="p"]').is(":visible") === false) {
                        $('ul.errors-list').hide();
                        $('ul.errors-list').parent().hide();
                    }
                    element = this.settings._getIndicatorElement(element);
                    $(element).removeClass(this.settings.errorElementClass).removeClass(errorClass);
                },
                _getIndicatorElement: function (element) {
                    if ($(element).attr("type") == "hidden" && $(element).parents("ul.lm__form-dropdown"))
                        return $(element).parents("ul.lm__form-dropdown").find("li.showcase > a").get(0);
                    else
                        return element;
                }
            });
        }

        $("#calculate_delivery_fee").bind("click", function (e) {
            console.log("called from js file");

            if (!$("#calculateForm").valid()) {
                return;
            }
            if ($('.calculate_result .calculate_fee')) {
                $('.calculate_result .calculate_fee').html('...');
            }
            $("#loaderCalculation").show();
            var url = "/api/deliveryfee/calculate";
            var calculateObj = getCalculateObject();

            $.ajax({
                type: "post",
                data: calculateObj,
                dataType: "html",
                url: url,
                success: function (data) {
                    if (data.indexOf("<html>") > 0)
                        window.location.href = "/";
                    else
                        $(".calculate_result").html(data);
                },
                complete: function (jqXHR) {
                    $('#loaderCalculation').hide();
                },
                error: function () {
                    $(".calculate_result").html('');
                }
            });

        });

        $("#calculateForm").find(".showcase .dropdown li a").click(function () {
            var inputElement = $(this).parents(".showcase").find("input.form-element");
            var inputSelector = inputElement.attr('id');
            $("#calculateForm").validate().element('#' + inputSelector);
        });
    }

    function getCalculateObject() {
        return {
            supplier: $('.calculate_supplier').val(),
            lorryType: $('#LorryType').val(),
            deliveryAddressId: $('#DeliveryAdress').val(),
            quantity: $('.calculate_quantity').val(),
            deliveryDate: $('.calculate_deliveryDate').val(),
            itemId: $('#Artikel_Frakt').val(),
            isInternal: $('#isInternal').val()
        };
    }
});